import React from 'react'
import GalleryPhotoCard from 'e-submission/components/Card/GalleryPhotoCard'
import { CheckedCard, NotCheckedCard, NotCheckedWithInputCard } from 'e-submission/components/Card/DocumentCard'

const GalleryPhotoCardWrapper = ({ value: documents, validate: validateFile, isBrowseFile, icon = 'camera', ...props }) => {
  const action = window.cordova && !isBrowseFile ? 'ถ่ายรูป' : 'แนบรูป'

  return (
    <div>
      {documents.map((documentProps, index) => (
        <GalleryPhotoCard
          key={index}
          icon={icon}
          action={action}
          validateFile={validateFile}
          CheckedComponent={CheckedCard}
          NotCheckedComponent={documentProps.editable ? NotCheckedWithInputCard : NotCheckedCard}
          {...documentProps}
          {...props}
        />
      ))}
    </div>
  )
}

export default (hoc) => hoc(GalleryPhotoCardWrapper)
